import { render } from "./ProductComp.vue?vue&type=template&id=16deda69&scoped=true"
import script from "./ProductComp.vue?vue&type=script&lang=js"
export * from "./ProductComp.vue?vue&type=script&lang=js"

import "./ProductComp.vue?vue&type=style&index=0&id=16deda69&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16deda69"]])

export default __exports__